export enum PatientType {
    DECEASED = 'Deceased',
    PATIENT = 'Patient'
}